export const initialState = {
  UploadedFileURL: ""
};
